import { BUSINESS } from "./business";

/**
 * A compact "Registered Entity" block for legal / policy pages.
 * Placed at the top of each legal page so verifiers (Meta, Google, browsers,
 * consumer courts) can clearly identify the controlling legal entity.
 */
export default function RegisteredEntityBlock() {
  return (
    <div className="nb-card p-4 sm:p-5 bg-[#FFD166]/40 space-y-2 text-sm" data-testid="registered-entity-block">
      <p className="text-[10px] font-bold tracking-[0.2em] uppercase text-[#4A4A4A]">Registered entity</p>
      <p className="font-heading text-base font-black leading-tight">
        {BUSINESS.legalName} · {BUSINESS.organizationType}
      </p>
      <p className="font-semibold">
        Operated by {BUSINESS.ownerName} · Udyam Reg.{" "}
        <span className="font-mono">{BUSINESS.udyamNumber}</span>
      </p>
      <p className="font-semibold text-[13px] text-[#4A4A4A]">
        {BUSINESS.address.formatted} ·{" "}
        <a href={`tel:${BUSINESS.phone}`} className="underline text-[#111111]">{BUSINESS.phoneDisplay}</a>{" · "}
        <a href={`mailto:${BUSINESS.email}`} className="underline text-[#111111]">{BUSINESS.email}</a>
      </p>
    </div>
  );
}
